<template>
    <div class="md:w-11/12 w-full flex  sm:h-auto flex-wrap mx-auto shadow-xl bg-white p-2 ">

      <div class="w-full flex sm:w-11/12 mx-auto">
        <div class=" flex flex-row w-full">

          <div class="flex-1">
            <div class="w-max mx-auto sm:mx-0 relative">
              <a class=" cursor-pointer transition duration-500 ease-in-out   xs:flex items-center" @click="updatebookmarkFilter('like')" v-bind:class="{'active': bookmark === 'like', 'non-active': bookmark !== 'like'}">
                <img class=" mx-auto h-6 sm:px-4 sm:my-4 my-2" src="/img/myle/svg/ic_lowerBarLiked.svg" alt="">
                <span class="text-gray-400 pr-4 xs:block hidden text-center ">Events I Like</span>
                <span class="text-gray-400 text-sm xs:hidden block text-center ">My Likes</span>
              </a>
            </div>
          </div>

          <div class="flex-1">
            <div class="w-max  mx-auto relative">
              <a class="cursor-pointer transition duration-500 ease-in-out   xs:flex items-center"  @click="updatebookmarkFilter('love')"  v-bind:class="{'active': bookmark === 'love', 'non-active': bookmark !== 'love'}">
                <img class=" mx-auto h-6 sm:px-4 sm:my-4 my-2" src="/img/myle/svg/ic_lowerbarLoved.svg" alt="">
                <span class="text-gray-400 pr-4 xs:block hidden  text-center ">Events I Love</span>
                <span class="text-gray-400 text-sm xs:hidden block text-center ">My Loves</span>
              </a>
            </div>
          </div>


          <div class="flex-1 ">
            <div class="w-max sm:float-right mx-auto sm:mx-0 relative">
              <a class="cursor-pointer transition duration-500 ease-in-out   xs:flex items-center"  @click="updatebookmarkFilter('attend')"  v-bind:class="{'active': bookmark === 'attend', 'non-active': bookmark !== 'attend'}">
                <img class=" mx-auto h-6 sm:px-4 sm:my-4 my-2" src="/img/myle/svg/ic_lowerbarAttending.svg" alt="">
                <span class="text-gray-400 pr-4 xs:block hidden  text-center ">Events I’m Attending</span>
                <span class="text-gray-400 text-sm xs:hidden block text-center ">My Attendings</span>
              </a>
            </div>
          </div>

        </div>
      </div>

    </div>
</template>
<script>
  import { mapMutations, mapState } from 'vuex';
  export default {
    name: "suboptionbar",
    data() {
      return {}
    },
    props: {},
    methods: {
      ...mapMutations('events', ['updatebookmarkFilter']),
    },
    computed: {
      ...mapState('events', ['bookmark']),
    }
  };
</script>
